import { Column, Heading } from '@stenajs-webui/core';
import type { FC } from 'react';

interface Props {
  className?: string;
  label: string;
}

export const PaymentTableHeaderCell: FC<Props> = ({ label, className }) => (
  <Column className={'heading ' + className}>
    <Heading variant={'h6'}>{label}</Heading>
  </Column>
);
